require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-viebel-meta-tags-re-re.json") })
        }
      }, "path---package-unpublished-viebel-meta-tags-re-re");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-viebel-meta-tags-re-re!./.cache/json/package-unpublished-viebel-meta-tags-re-re.json
// module id = 971
// module chunks = 231608221292675